import ValidateField from '../hooks/useValid';
import { ValidateName } from '../constants/ValidateNameConstants';


export default function ValidateCustomer(values, customerData) {
    let errors = {};

    errors.customerName = ValidateField(
        values.customerName,
        ValidateName?.CUSTOMER_NAME,
        ValidateName?.CUSTOMER_NAME,
        [ValidateName?.REQUIRED, ValidateName?.NOT_VALID, ValidateName?.MIN_LENGTH],
    );

    errors.phone = ValidateField(
        values.phone,
        ValidateName?.PHONE_NUMBER,
        ValidateName?.PHONE_NUMBER,
        [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE],
    );
    if (values.website !== "") {
        errors.website = ValidateField(
            values.website,
            ValidateName?.WEBSITE,
            ValidateName?.WEBSITE,
            [ValidateName?.ISVALID_URL],
        );
    }
    errors.email = ValidateField(
        values.email,
        ValidateName?.EMAIL,
        ValidateName?.EMAIL,
        [ValidateName?.REQUIRED, ValidateName?.ISVALID_EMAIL, ValidateName?.DUPLICATE_EMAIL],
        undefined,
        customerData
    );
    errors.country = ValidateField(
        values.countryId,
        ValidateName?.CUSTOMER_COUNTRY,
        ValidateName?.CUSTOMER_COUNTRY,
        [ValidateName?.REQUIRED],
    );
    errors.address = ValidateField(
        values.address,
        ValidateName?.CUSTOMER_ADDRESS,
        ValidateName?.CUSTOMER_ADDRESS,
        [ValidateName?.REQUIRED],
    );
    errors.engineer = ValidateField(
        values.assignedEngineerId,
        ValidateName?.ALLOCATEDTO,
        ValidateName?.ALLOCATEDTO,
        [ValidateName?.REQUIRED],
    );
    errors.distributor = ValidateField(
        values.distributorId,
        ValidateName?.DISTRIBUTOR,
        ValidateName?.DISTRIBUTOR,
        [ValidateName?.REQUIRED],
    );
    let error = {}
    Object.keys(errors).map((key, index) => {
        if (errors[key] !== undefined)
            error[key] = errors[key]
    })

    return error;
}


